module.exports = __webpack_public_path__ + "static/media/community-icon.72eeceac.svg";